<template>
    <transition name="slide">
        <div v-if="!editDisabled" class="dashboard-library">
            <transition name="vue-table-loader">
                <div class="vue-details-loader"v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </transition>
            <div class="heading">
                <div class="title">Add New Widget</div>
                <a v-if="$parent.dashboardCreateMode != true" @click.prevent="closeLibrary()" class="close-library"><i class="fa fa-times"></i></a>
            </div>
            <div class="library-listing">
                <draggable class="dragArea row" group="widgetData" :disabled="editDisabled" v-model="widgetLibrary">
                    <div :class="widgetSize(widget.size)" v-for="(widget, index) in widgetLibrary">
                        <plan-details v-if="widget.template == 'plan-details'" :plan-details="widget.data"></plan-details>
                        <user-activity v-if="widget.template == 'user-activity'" :edit-disabled="editDisabled" :widget-data="widget"></user-activity>
                        <product-activity v-if="widget.template == 'product-activity'" :edit-disabled="editDisabled" :widget-data="widget"></product-activity>
                        <big-value-widget v-if="widget.template == 'big-value'" :edit-disabled="editDisabled" :widget-data="widget"></big-value-widget>
                        <widget-chart v-if="widget.template == 'chart'" :edit-disabled="editDisabled" :chartId="'chart_'+ index" :chart-data="widget"></widget-chart>
                        <widget-list v-if="widget.template == 'list'" :edit-disabled="editDisabled" :widget-data="widget"></widget-list>
                        <widget-triple-chart v-if="widget.template == 'triple-chart'" :edit-disabled="editDisabled" :chartId="'chart_'+ index" :chart-data="widget"></widget-triple-chart>
                        <widget-json v-if="widget.template !== 'plan-details' && widget.template !== 'user-activity' && widget.template !== 'product-activity' && widget.template !== 'big-value' && widget.template !== 'chart' && widget.template !== 'list' && widget.template !== 'triple-chart'" :edit-disabled="editDisabled" :widget-data="widget"></widget-json>
                    </div>
                </draggable>
            </div>
            <div class="info-blurb">Drag and drop to place a new widget</div>
        </div>
    </transition>
</template>
<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';
    import BigValueWidget from './widgets/big-value-widget.vue';
    import WidgetChart from './widgets/widget-chart.vue';
    import WidgetJson from './widgets/widget-json.vue';
    import UserActivity from './widgets/user-activity.vue';
    import ProductActivity from './widgets/product-activity.vue';
    import PlanDetails from './widgets/plan-details.vue';
    import WidgetList from './widgets/widget-list.vue';
    import WidgetTripleChart from './widgets/widget-triple-chart.vue';

    import draggable from 'vuedraggable'

    Vue.use(VueEvents)

    export default {
        name: 'dashboard-library',
        props: ['editDisabled'],
        components:{
            PlanDetails,
            BigValueWidget,
            WidgetChart,
            ProductActivity,
            UserActivity,
            WidgetList,
            WidgetTripleChart,
            WidgetJson,
            draggable
        },
        data() {
            return {
                uiStates: {
                    showLoading: true,
                },
                widgetLibrary: [],
            }
        },
        mounted() {
            this.getWidgets();
        },
        methods: {
            getWidgets: function(){
                axios.get(base_url+'/pimapi/widgets', {

                })
                .then(function(response) {
                    this.widgetLibrary = response.data.widgets.filter(widget => widget.configuration === undefined || widget.configuration === null);
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function(error) {
                }.bind(this));
            },
            closeLibrary: function(){
                this.$parent.uiStates.editDisabled = true;
            },
            widgetSize: function (size) {
                if (size == 's') {
                    return 'col-md-4';
                }
                if (size == 'm') {
                    return 'col-md-8';
                }
                if (size == 'l') {
                    return 'col-md-12';
                }
            }
        },
    };
</script>

<style lang="scss">
.vue-details-loader{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #25618f;
    background: white;
    z-index: 12;
    text-align: center;
    padding: 196px 10px;
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s;
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateY(684px);
    bottom: -684px;
}
.dashboard-library{
    position: fixed;
    padding: 25px 0 20px 0;
    bottom: 0px;
    left: 200px;
    right: 0px;
    background: #FFFFFF;
    z-index: 2;
    box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
    height:411px;
    .heading{
        z-index: 1;
        position: absolute;
        top:0;
        left:0;
        right:0;
        padding: 0px 20px 30px 20px;
       background: -moz-linear-gradient(top,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%);
       background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 60%,rgba(255,255,255,0) 100%);
       background: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 60%,rgba(255,255,255,0) 100%);
       filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 );

        .title{
            padding-top: 20px;
            font-size: 18px;
            color: #1F2529;
            text-align: left;
        }
        .close-library{
            position: absolute;
            top:15px;
            right:23px;
            font-size: 20px;
            color: #576670;
        }
    }
    .library-listing{
        position: relative;
        height: 334px;
        padding: 12px 20px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: #DEE0E1;
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: 0px;
            border-radius:5px;
        }
        &::-webkit-scrollbar-thumb {
            background: #25628F;
            border-radius:5px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #25628F;
        }
    }
    .widget-item{
        overflow:hidden;
        position: relative;
        margin-top:30px;
        padding:0 20px;
        background: #FFFFFF;
        border: 1px solid #DEE0E1;
        border-radius: 12px;
        min-height:250px;
        max-height:250px;
        box-shadow: 0 0 3px 1px rgba(0,0,0,0.10);
        .widget-heading{
            position: relative;
            z-index:2;
            border-bottom:1px solid #F1F2F2;
            padding-top:15px;
            padding-bottom:15px;
            position: relative;
            .title{
                float: left;
                font-size: 18px;
                color: #848484;
                text-align: left;
            }
        }
        .remove-widget{
            display: none;
        }
        .pim-informational{
            .plan-details{
                border-right: 1px solid #F1F2F2;
            }
        }
    }
    .info-blurb{
        position: absolute;
        bottom: 0px;
        padding-bottom: 33px;
        padding-top: 33px;
        left:0;
        right:0;
        font-size: 12px;
        color: #6C6C6C;
        text-align: center;
        background: -moz-linear-gradient(top,  rgba(30,87,153,0) 0%, rgba(255,255,255,1) 40%, rgba(255,255,255,1) 100%);
        background: -webkit-linear-gradient(top,  rgba(30,87,153,0) 0%,rgba(255,255,255,1) 40%,rgba(255,255,255,1) 100%);
        background: linear-gradient(to bottom,  rgba(30,87,153,0) 0%,rgba(255,255,255,1) 40%,rgba(255,255,255,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#001e5799', endColorstr='#ffffff',GradientType=0 );

    }
}
.ks-sidebar-compact{
    .dashboard-library{
        left:70px;
    }
}
</style>
